import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@jfh/intake-shared/tokens.css';
import './styles.css';
import './base.css';
import { App } from './App.js';

// Staging builds (`build:staging`, see vite.config.ts) flag every page so test data
// is never mistaken for live.
const staging = import.meta.env.VITE_STAGING === 'true';
if (staging) document.title = `[STAGING] ${document.title}`;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {staging && <div className="staging-banner">STAGING — test data only</div>}
    <App />
  </StrictMode>,
);
